// Sugerencias del campo «¿Dónde?» del buscador. Antes se pedía Text Search de Google con el texto
// suelto: «Palermo» devolvía estaciones, shoppings y departamentos con la misma dirección
// («C1425 Cdad. Autónoma de Buenos Aires» seis veces) y «kfc» devolvía el local de KFC. Ahora se
// usa el Autocomplete de Cyclone restringido a zonas (`type=(regions)`: barrios, localidades,
// partidos y provincias de la Argentina) y acá se arma la etiqueta, la segunda línea y se sacan
// los repetidos.

// Tipos de Google que son zonas y no comercios. Si una respuesta trae otra cosa (por ejemplo,
// si Cyclone cae al Text Search de respaldo), se descarta.
const GEO_TYPES = new Set([
  'locality',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'neighborhood',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'administrative_area_level_3',
  'postal_code',
  'colloquial_area',
  'political'
]);

const MAX_SUGGESTIONS = 6;

export const locationSuggestionsUrl = (apiUrl, text) =>
  `${apiUrl}/google/places/autocomplete/${encodeURIComponent(text)}?country=Argentina&type=${encodeURIComponent('(regions)')}`;

const isGeographic = (types) => Array.isArray(types) && types.some((type) => GEO_TYPES.has(type));

// «Palermo, Ciudad Autónoma de Buenos Aires, Argentina» → «Ciudad Autónoma de Buenos Aires».
export function secondaryLine(fullText, mainText) {
  let rest = (fullText || '').trim();
  if (mainText && rest.toLowerCase().startsWith(mainText.toLowerCase())) {
    rest = rest.slice(mainText.length).replace(/^\s*,\s*/, '');
  }
  rest = rest.replace(/,?\s*Argentina\s*$/i, '').trim();
  return rest || 'Argentina';
}

const comparable = (text) =>
  String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\bcdad\b\.?/g, 'ciudad')
    .replace(/^provincia de\s+/, '')
    .replace(/[.\s]+/g, ' ')
    .trim();

/**
 * Clave de repetido: la zona + su provincia (el último tramo de la segunda línea). Google devuelve
 * el mismo lugar con y sin el partido o departamento en el medio («Palermo, Salta» y «Palermo,
 * Anta, Salta»): es una sola sugerencia y queda la primera, que es la que Google ordenó arriba.
 */
export function suggestionKey(label, secondary) {
  const parts = String(secondary || '').split(',');
  return `${comparable(label)}|${comparable(parts[parts.length - 1])}`;
}

/**
 * @param {Array} places respuesta de `/google/places/autocomplete/:q` (formato de Cyclone)
 * @returns {Array<{ id: string, label: string, secondary: string, location?: object }>}
 */
export function toLocationSuggestions(places) {
  if (!Array.isArray(places)) return [];
  const seen = new Set();
  const result = [];
  for (const place of places) {
    if (!place?.id || !isGeographic(place.types)) continue;
    const label = (place.displayName?.text || place.formattedAddress || '').trim();
    if (!label) continue;
    const secondary = secondaryLine(place.formattedAddress, label);
    const key = suggestionKey(label, secondary);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push({ id: place.id, label, secondary, location: place.location });
    if (result.length >= MAX_SUGGESTIONS) break;
  }
  return result;
}
